import { render, staticRenderFns } from "./ResultstypeProduct.vue?vue&type=template&id=7743310e&"
import script from "./ResultstypeProduct.vue?vue&type=script&lang=js&"
export * from "./ResultstypeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ResultstypeProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports